import styled from '@emotion/styled'
import { MultiButton } from './MultiButton'
import * as constants from 'view/styles/constants'

export const MinimalIconButton = styled(MultiButton)`
  display: flex;
  background-color: 'transparent';
  color: ${props => (props.disabled ? constants.CORE_PRIMARY_3 : constants.CORE_PRIMARY_5)};
  border-color: transparent;
  margin: 0;
  padding: 0;
  border-style: solid;

  &:hover:not(:disabled) {
    background-color: ${constants.CORE_PRIMARY};
    border-color: ${constants.CORE_PRIMARY_3};
  }

  border-radius: 6px;
  height: 26px;
  width: 26px;
  min-width: 26px;
  flex-grow: 0;
  svg {
    padding-right: 0;
    width: auto;
    height: 100%;
  }
`
